import { Box } from '@material-ui/core'
import { useThemeQueries } from 'views/theme'
import { useStyles } from './dialog-exibicao-html-styles';
import { DialogSaurus } from 'views/components/dialog/dialog-saurus/dialog-saurus'
import ContentEditable from 'react-contenteditable'

type Props = {
    openned: boolean
    onClose: () => void
    html: string
}

export default function ExibicaoHtml({ openned, html, onClose
}: Props) {
    const classes = useStyles();
    const { isMobile } = useThemeQueries();
    return (
        <DialogSaurus
            aberto={openned}
            titulo={'Exibir HTML'}
            tamanho="xl"
            fullScreen={isMobile}
            handleClickClose={onClose}
            isButtonTitleClose
        >
            <Box className={classes.cardContainer}>
                <Box className={classes.cardContent}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                        <ContentEditable
                            disabled
                            html={html}
                            className={classes.htmlContainer}
                            onChange={() => {
                            }}
                        />
                    </Box>
                </Box>
            </Box>
        </DialogSaurus>
    )
}